import { SEO } from '../seo/SEO';
import { useI18n } from '../i18n';
import { AppHeader } from '../components/AppHeader';
import { useSmartBack } from '../hooks/useSmartBack';
import './PrivacyPage.css';

export function PrivacyPage() {
  const { t } = useI18n();
  const p = t.privacyPage as any;
  const smartBack = useSmartBack('/');

  return (
    <div className="privacy-page">
      <SEO path="/gizlilik" title={p.seoTitle} description={p.seoDesc} />
      <div className="privacy-inner">
        <AppHeader onBack={smartBack} backLabel={t.common.backToHome} title={p.pageTitle} />
      </div>

      <main className="privacy-content">
        <p className="privacy-meta">{p.lastUpdated}</p>

        <section>
          <h2>{p.s1Title}</h2>
          <p>{p.s1Body}</p>
        </section>

        <section>
          <h2>{p.s2Title}</h2>
          <p>{p.s2Intro}</p>
          <ul>
            <li>{p.s2Item1}</li>
            <li>{p.s2Item2}</li>
            <li>{p.s2Item3}</li>
            <li>{p.s2Item4}</li>
            <li>{p.s2Item5}</li>
            <li>{p.s2Item6}</li>
            <li>{p.s2Item7}</li>
            <li>{p.s2Item8}</li>
            <li>{p.s2Item9}</li>
            <li>{p.s2Item10}</li>
          </ul>
          <p>{p.s2Outro}</p>
        </section>

        <section>
          <h2>{p.s3Title}</h2>
          <ul>
            <li>{p.s3Item1}</li>
            <li>{p.s3Item2}</li>
            <li>{p.s3Item3}</li>
            <li>{p.s3Item4}</li>
            <li>{p.s3Item5}</li>
          </ul>
          <p>{p.s3Outro}</p>
        </section>

        <section>
          <h2>{p.s4Title}</h2>
          <p>{p.s4Body}</p>
        </section>

        <section>
          <h2>{p.s5Title}</h2>
          <p>{p.s5Body}</p>
        </section>

        <section>
          <h2>{p.s6Title}</h2>
          <p>{p.s6Body}</p>
        </section>

        <section>
          <h2>{p.s7Title}</h2>
          <p>{p.s7Intro}</p>
          <ul>
            <li>{p.s7Item1}</li>
            <li>{p.s7Item2}</li>
            <li>{p.s7Item3}</li>
            <li>{p.s7Item4}</li>
          </ul>
          <p>{p.s7Outro}</p>
        </section>

        <section>
          <h2>{p.s8Title}</h2>
          <p>{p.s8Body}</p>
        </section>

        <section>
          <h2>{p.s9Title}</h2>
          <p>{p.s9Body}</p>
        </section>

        <section>
          <h2>{p.s10Title}</h2>
          <p>{p.s10Body}</p>
        </section>

        <section>
          <h2>{p.s11Title}</h2>
          <p>
            {p.s11ContactPre}
            <a href={`mailto:${p.s11Email}`}>{p.s11Email}</a>
          </p>
        </section>
      </main>
    </div>
  );
}
